import { render, staticRenderFns } from "./user-select.vue?vue&type=template&id=37ea58fe&scoped=true"
import script from "./user-select.vue?vue&type=script&lang=js"
export * from "./user-select.vue?vue&type=script&lang=js"
import style0 from "./user-select.vue?vue&type=style&index=0&id=37ea58fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ea58fe",
  null
  
)

export default component.exports